var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showReceptionIframe)?_c('iframe',{attrs:{"id":"wmsIframe","src":_vm.wmsReceptionUrl}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }